import { format, parseISO } from 'date-fns'

export function formatInsightDate(iso: string): string {
  return format(parseISO(iso), 'd MMM yyyy')
}
